// React Components
import React, { Fragment, useState } from 'react';

// Ant Design Components
import { Popconfirm, Popover, Button, Dropdown, Menu, notification } from 'antd';
import {
  EditOutlined,
  LoadingOutlined,
  CaretDownOutlined,
  SwapOutlined,
  SwapRightOutlined,
  SwapLeftOutlined
} from '@ant-design/icons';

// FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

// Utilities & Helpers
import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';
import { v4 as uuidv4 } from 'uuid';

// UI Components
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';

const ViewStHeaders = ({
  selectedSt,
  user,
  isQuickView,
  updateStStatusLoading,
  deleteStLoading,
  conditionalGRN,
  selectedSTId,
  history,
  callback,
  updateStStatus,
  deleteSt,
  createStShortClose,
  createStShortCloseLoading,
  downloadDocument,
  setShowDCDrawer,
  setShowNewGrnForm,
}) => {
  const getTransferType = (record) => {
    return (
      <Fragment>
        {record?.st_receiving_status && (
          <div className="view-document__title-status" style={{ backgroundColor: Helpers.getStatusColor(record?.st_receiving_status).color, display: 'flex', }}>
            {Helpers.getStatusColor(record?.st_receiving_status).text}
          </div>
        )
        }
        {
          record?.is_short_closed && (
            <div className="view-document__title-status" style={{ backgroundColor: Helpers.getStatusColor('CONFIRMED').color, display: 'flex', }}>
              Short Closed
            </div>
          )
        }
        {
          record?.source_department_info?.tenant_id === record?.destination_department_info?.tenant_id && (
            <div className="view-document__title-status" style={{ backgroundColor: '#5287da', display: 'flex', }}>
              <SwapOutlined />
              <H3Text text="Internal" className="#5287da" />
            </div>
          )
        }
        {
          record?.source_department_info?.tenant_id !== record?.destination_department_info?.tenant_id
          && record?.source_department_info?.tenant_id === user?.tenant_info?.tenant_id
          && (
            <div className="view-document__title-status" style={{ backgroundColor: '#f15353', display: 'flex', }}>
              <SwapRightOutlined />
              <H3Text text="Outgoing" className="" />
            </div>
          )
        }
        {
          record?.source_department_info?.tenant_id !== record?.destination_department_info?.tenant_id
          && record?.destination_department_info?.tenant_id === user?.tenant_info?.tenant_id
          && (
            <div className="view-document__title-status" style={{ backgroundColor: '#2fbc6e', display: 'flex', }}>
              <SwapLeftOutlined />
              <H3Text text="Incoming" className="" />
            </div>
          )
        }
      </Fragment >
    );
  }
  const [currentUpdate, setCurrentUpdate] = useState('');
  const [cancellationPop, setCancellationPop] = useState('');
  const [cancellationReason, setCancellationReason] = useState('');
  const [openPopOver, setOpenPopOver] = useState(false);
  const [shortCloseReason, setShortCloseReason] = useState('');

  return (
    <div className="view-document__title">
      <div className="view-document__title-number-wrapper">
        <H3Text
          text={selectedSt?.stock_transfer_number}
          className="view-document__title-number"
        />
        <div
          className="view-document__title-status"
          style={{ backgroundColor: Helpers.getStatusColor(selectedSt?.status).color, marginLeft: '10px' }}
        >
          {Helpers.getStatusColor(selectedSt?.status).text}
        </div>
        {getTransferType(selectedSt)}
      </div>

      {!isQuickView && (
        <div className="view-document__title-actions">
          <div className="action-buttons">
            {Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.UPDATE).includes(selectedSt?.source_department_info?.tenant_id) && ['DRAFT'].includes(selectedSt?.status) && window.screen.width > 425 && Helpers.getPermission(Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.UPDATE, user) && (
              <H3Text
                text={<div onClick={() => {
                  if (['ISSUED'].includes(selectedSt?.status)) {
                    notification.open({
                      type: 'error',
                      message: 'You cannot update a stock transfer request once it is issued',
                      description: 'Please cancel this request and create a new one',
                      duration: 6,
                      placement: 'top',
                    });
                  } else {
                    history.push(`/inventory/stock-transfer/update/${selectedSt?.stock_transfer_id}`);
                  }
                }}><EditOutlined /></div>}
                className="action-button"
              />
            )}

            <H3Text
              text={<FontAwesomeIcon icon={faPrint} style={{ fontSize: '16px', width: '35px', textAlign: 'center' }} />}
              onClick={() => downloadDocument({
                url: `${Constants.ST}/download?stock_transfer_id=${selectedSt?.stock_transfer_id}&tenant_id=${selectedSt?.source_department_info?.tenant_id}&type=pdf`,
                document_type: 'STOCK_TRANSFER',
                document_number: selectedSt?.stock_transfer_number,
                key: uuidv4(),
              })}
              className="action-button"
            />
          </div>

          <div className="action-buttons">
            {Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.UPDATE).includes(selectedSt?.source_department_info?.tenant_id) && ['DRAFT'].includes(selectedSt?.status) && Helpers.getPermission(Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.UPDATE, user) && (
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to issue this stock transfer request?"
                onConfirm={() => {
                  setCurrentUpdate('ISSUED')
                  updateStStatus({
                    status: 'ISSUED',
                    stock_transfer_id: selectedSt.stock_transfer_id,
                    tenant_id: selectedSt?.source_department_info?.tenant_id,
                  }, () => {
                    callback()
                    setCurrentUpdate('')
                  });
                }}
                okText="Yes"
                cancelText="No"
              >
                <H3Text
                  text={<div style={{ textAlign: 'center' }}>{updateStStatusLoading && currentUpdate === 'ISSUED' ? <LoadingOutlined /> : <span>Confirm Stock Transfer</span>}</div>}
                  className="action-button action-button-big"
                />
              </Popconfirm>
            )}

            {Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.UPDATE).includes(selectedSt?.source_department_info?.tenant_id) && selectedSt?.status?.toLowerCase() !== 'void' && Helpers.getPermission(Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.UPDATE, user) && (
              <Popover
                placement="topRight"
                title="Are you sure you want to cancel?"
                open={cancellationPop}
                content={
                  <React.Fragment>
                    <H3FormInput
                      name="field name"
                      type="text"
                      containerClassName="orgInputContainer create__right-input"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      placeholder=""
                      onChange={(e) => setCancellationReason(e.target.value)}
                      value={cancellationReason}
                      label="Reason"
                      maxlength="100"
                      required
                      showError={currentUpdate === 'VOID' && !cancellationReason}
                    />
                    <div className="view-document__cancellation-buttons">
                      <Button size="small" onClick={() => setCancellationPop(false)}>No</Button>
                      <Button
                        onClick={() => {
                          if (selectedSt?.reference_dc?.length) {
                            notification.open({
                              type: 'error',
                              message: 'You have a delivery challan created against this stock transfer.',
                              description: 'Please cancel delivery challan first',
                              duration: 6,
                              placement: 'top',
                            });
                          } else {
                            setCurrentUpdate('VOID')
                            if (cancellationReason) {
                              updateStStatus({
                                tenant_id: selectedSt?.source_department_info?.tenant_id,
                                status: 'VOID',
                                stock_transfer_id: selectedSt.stock_transfer_id,
                                reason_of_cancellation: cancellationReason,
                              }, () => {
                                setCurrentUpdate('')
                                setCancellationReason('')
                                setCancellationPop(false)
                                callback()
                              });
                            }
                          }
                        }}
                        type="primary"
                        size="small"
                      >Yes</Button>
                    </div>
                  </React.Fragment>
                }
                trigger="click"
              >
                <H3Text
                  text={<div style={{ width: '50px', textAlign: 'center' }}>{updateStStatusLoading && currentUpdate === 'VOID' ? <LoadingOutlined /> : <span>Cancel</span>}</div>}
                  onClick={() => setCancellationPop(true)}
                  className="action-button action-button-big"
                />
              </Popover>
            )}

            {Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.UPDATE).includes(selectedSt?.source_department_info?.tenant_id) && selectedSt?.status === 'VOID' && Helpers.getPermission(Helpers.permissionEntities.STOCK_TRANSFER, Helpers.permissionTypes.DELETE, user) && (
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete the transfer?"
                onConfirm={() => {
                  deleteSt({
                    tenant_id: selectedSt?.source_department_info?.tenant_id,
                    stock_transfer_id: selectedSt.stock_transfer_id,
                  }, () => {
                    if (selectedSTId) callback();
                    else history.push('/inventory/stock-transfer');
                  });
                }}
                okText="Yes"
                cancelText="No"
              >
                <H3Text
                  text={<div>{deleteStLoading ? <LoadingOutlined /> : <span>Delete</span>}</div>}
                  className="action-button action-button-big"
                />
              </Popconfirm>
            )}

            {['ISSUED'].includes(selectedSt?.status) && (
              <Dropdown
                overlay={
                  <Menu>
                    {['ISSUED'].includes(selectedSt?.status) &&
                      Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.CREATE).includes(selectedSt?.source_department_info?.tenant_id) &&
                      window.screen.width > 425 &&
                      user?.tenant_info?.inventory_config?.sub_modules?.delivery_challan?.is_active && (
                        <Menu.Item>
                          <H3Text onClick={() => setShowDCDrawer(true)} text="+ Delivery Challan" className="action-button action-button-big" />
                        </Menu.Item>
                      )}

                    {['ISSUED'].includes(selectedSt?.status) &&
                      Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.CREATE).includes(selectedSt?.destination_department_info?.tenant_id) &&
                      window.screen.width > 425 &&
                      !selectedSt?.is_short_closed &&
                      selectedSt?.stock_transfer_lines?.length > 0 &&
                      !selectedSt?.stock_transfer_lines?.every(item => item?.quantity === item?.consumed_qty) &&
                      conditionalGRN && (
                        <Menu.Item>
                          <H3Text onClick={() => setShowNewGrnForm(true)} text="+ Goods Receiving" className="action-button action-button-big" />
                        </Menu.Item>
                      )}

                    {selectedSt?.st_receiving_status === 'PARTIALLY_RECEIVED' &&
                      !(selectedSt?.source_department_info?.tenant_id !== selectedSt?.destination_department_info?.tenant_id &&
                        selectedSt?.source_department_info?.tenant_id === user?.tenant_info?.tenant_id) && (
                        <Popover
                          placement="bottomRight"
                          title="Are you sure you want to short close the Stock transfer?"
                          open={openPopOver}
                          content={
                            <React.Fragment>
                              <H3FormInput
                                name="field name"
                                type="text"
                                containerClassName="orgInputContainer create__right-input"
                                labelClassName="orgFormLabel"
                                inputClassName="orgFormInput"
                                placeholder=""
                                onChange={(e) => setShortCloseReason(e.target.value)}
                                value={shortCloseReason}
                                label="Reason"
                                maxlength="100"
                                required
                                showError={currentUpdate === 'VOID' && !shortCloseReason}
                              />
                              <div className="view-document__cancellation-buttons">
                                <Button size="small" onClick={() => setOpenPopOver(false)}>No</Button>
                                <Button
                                  onClick={() => {
                                    createStShortClose({
                                      tenant_id: selectedSt?.source_department_info?.tenant_id,
                                      stock_transfer_id: selectedSt.stock_transfer_id,
                                      short_close_reason: shortCloseReason,
                                    }, () => {
                                      callback()
                                    });
                                    setOpenPopOver(false);
                                  }}
                                  type="primary"
                                  size="small"
                                  disabled={!shortCloseReason}
                                >Yes</Button>
                              </div>
                            </React.Fragment>
                          }
                          trigger="click"
                        >
                          <H3Text
                            text={<div style={{ width: '80px', textAlign: 'center' }}>{createStShortCloseLoading && currentUpdate === 'VOID' ? <LoadingOutlined /> : <span> Short Close </span>}</div>}
                            onClick={() => setOpenPopOver(!openPopOver)}
                            className="action-button action-button-big"
                          />
                        </Popover>
                      )}
                  </Menu>
                }
                trigger={['click']}
                placement="topRight"
                dropdownStyle={{ zIndex: '2999 !important' }}
                getPopupContainer={(node) => node.parentElement}
              >
                <div style={{ width: '75px' }}>
                  <H3Text
                    text={<div style={{ display: 'flex', alignItems: 'center' }} onClick={(e) => e.preventDefault()}>More <CaretDownOutlined /></div>}
                    className="action-button action-button-big"
                    style={{ borderRight: '1px solid rgba(45, 124, 247, 0.5)' }}
                  />
                </div>
              </Dropdown>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewStHeaders;